import script from "./DebugPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DebugPanel.vue?vue&type=script&setup=true&lang=js"

import "./DebugPanel.vue?vue&type=style&index=0&id=33908a39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33908a39"]])

export default __exports__